import { ItemListSectionHeaderRowData } from "@/components/item-list/types";
import { MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import { ItemListTitleIcon } from "@/components/item-list/rows/components/item-list-title-icon";
import { StyledWrapper, StyledPrimaryText } from "./item-list-section-header-row.style";

interface Props {
  data: ItemListSectionHeaderRowData;
  className?: string;
}

export const ItemListSectionHeaderRow = ({ data, className }: Props) => {
  const { title, titleIcon } = data.payload;

  return (
    <StyledWrapper key={title} className={className}>
      {titleIcon && <ItemListTitleIcon titleIcon={titleIcon} />}
      <StyledPrimaryText
        color={MDSTextColor.Secondary}
        variant={MDSTextVariant.TextXs}
        weight={MDSTextWeight.SemiBold}
      >
        {title}
      </StyledPrimaryText>
    </StyledWrapper>
  );
};
